<template>
  <button v-if="isPriceBreakdown" @click="refresh">
    <i class="fas fa-search-dollar" />
  </button>
  <modal-window
    v-if="isBreakdown"
    :modal_open="true"
    title="Calculation Breakdown"
    :is-form="false"
    @close="isBreakdown = false"
  >
    <div class="flex flex-col gap-5">
      <table
        v-if="basketStore.currentItem.cost"
        class="table-fixed table-pattern border-collapse text-left border"
        style="min-width: 500px"
      >
        <thead>
          <tr>
            <th class="p-5 text-left">Description</th>
            <th class="p-5 text-left">Cost</th>
          </tr>
        </thead>
        <tbody class="w-full">
          <tr v-for="item in basketStore.currentItem.costBreakdown" :key="item.id">
            <td class="px-5 py-2" :class="{ fadeInAndOut: loading }">
              {{ item.description }}
            </td>
            <td class="px-5 py-2" :class="{ fadeInAndOut: loading }">
              <span v-if="!loading">
                {{ formatCurrency(basketStore.getCurrency, item.value) }}
              </span>
            </td>
          </tr>
          <tr class="!bg-white h-10" />
          <tr class="border">
            <td class="px-5 py-2 !bg-white" :class="{ fadeInAndOut: loading }"><b>Total</b></td>
            <td class="px-5 py-2 !bg-white" :class="{ fadeInAndOut: loading }">
              <b :class="{ 'opacity-0': loading }">
                {{ formatCurrency(basketStore.getCurrency, basketStore.currentItem.cost) }}
              </b>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table-fixed table-pattern border-collapse text-left border" style="min-width: 500px">
        <thead>
          <tr>
            <th class="p-5 text-left">Description</th>
            <th class="p-5 text-left">Price</th>
          </tr>
        </thead>
        <tbody class="w-full">
          <tr v-for="item in basketStore.currentItem.priceBreakdown" :key="item.id">
            <td class="px-5 py-2" :class="{ fadeInAndOut: loading }">
              {{ item.description }}
            </td>
            <td class="px-5 py-2" :class="{ fadeInAndOut: loading }">
              <span v-if="!loading">
                {{ formatCurrency(basketStore.getCurrency, item.value) }}
              </span>
            </td>
          </tr>
          <tr class="!bg-white h-10" />
          <tr class="border">
            <td class="px-5 py-2 !bg-white" :class="{ fadeInAndOut: loading }"><b>Total</b></td>
            <td class="px-5 py-2 !bg-white" :class="{ fadeInAndOut: loading }">
              <b :class="{ 'opacity-0': loading }">
                {{ formatCurrency(basketStore.getCurrency, basketStore.currentItem.price) }}
              </b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-right mt-10 flex flex-col 2xs:block">
      <button class="btn btn-lg 2xs:mr-1 mb-1 2xs:mb-0" @click.prevent="refresh">Refresh</button>
    </div>
  </modal-window>
</template>

<script>
import { mapStores } from 'pinia'
import { useCustomerStore } from '@/pinia/customer'
import { useAuthStore } from '@/pinia/auth'
import { useBasketStore } from '@/pinia/basket'
import { formatCurrency } from '@/utils/currency'

export default {
  setup() {
    return { formatCurrency }
  },
  data() {
    return {
      isBreakdown: false,
      loading: true,
      omitPriceBreakdown: true
    }
  },
  computed: {
    ...mapStores(useCustomerStore, useBasketStore, useAuthStore),
    isPriceBreakdown() {
      return (
        this.authStore.isBusiness ||
        (this.customerStore.customer?.financial?.omitPriceBreakdown === false && this.authStore.isPortal)
      )
    }
  },
  methods: {
    async refresh() {
      this.loading = true
      this.isBreakdown = true
      const item = await this.basketStore.loadItem({
        itemKey: this.$route.params.id,
        customerID: this.$route.params.customerId
      })
      this.item = await this.basketStore.SET_CURRENT_ITEM(item)
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  }
}
</script>

<style scoped>
.fadeInAndOut {
  opacity: 1;
  animation: fade 2s linear infinite;
}

@keyframes fade {
  0%,
  100% {
    opacity: 0.2;
  }

  50% {
    opacity: 1;
  }
}
</style>
